import { render, staticRenderFns } from "./WorkerWelcome.vue?vue&type=template&id=a3b3c80a&"
import script from "./WorkerWelcome.vue?vue&type=script&lang=js&"
export * from "./WorkerWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports